import { render } from "./NewLeaveApprove.vue?vue&type=template&id=24c46cda"
import script from "./NewLeaveApprove.vue?vue&type=script&lang=js"
export * from "./NewLeaveApprove.vue?vue&type=script&lang=js"

import "./NewLeaveApprove.vue?vue&type=style&index=0&id=24c46cda&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__